import React from 'react';

import {ELN_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';
// @ts-expect-error
// eslint-disable-next-line unused-imports/no-unused-imports
import PrintLabelButton from 'label-printing/PrintLabelButton';
import {ACTION_REFRESH} from 'notebook/store/VersioningConstants';
import {performClientSideWriteAction} from 'notebook/structured-tables/action-functions/PerformActionFunctions';
import {RESYNC_TABLE_LABEL} from 'notebook/tables/constants/TableConstants';
import Tooltip from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

export interface RefreshStructuredTableButtonProps {
  entryOrTemplateId: string;
  doRefresh: () => Promise<void>;
  structuredTableKind: string;
  disabled: boolean;
}

/**
 * Reusable component for refreshing structured table.
 */
export default class RefreshStructuredTableButton extends React.Component<RefreshStructuredTableButtonProps> {
  _handleRefreshCallback(): () => void {
    return () => {
      performClientSideWriteAction({
        entryOrTemplateId: this.props.entryOrTemplateId,
        loadingScreenMessage: 'Re-syncing...',
        autoSaverAction: ACTION_REFRESH,
        doPerformAction: this.props.doRefresh,
        analyticsEvent: ELN_ANALYTICS_ACTIONS.REFRESHED_STRUCTURED_TABLE,
        analyticsMetadata: {
          structuredTableKind: this.props.structuredTableKind,
          fileId: this.props.entryOrTemplateId,
        },
      });
    };
  }

  override render(): JSX.Element | null {
    return (
      <Tooltip title={RESYNC_TABLE_LABEL}>
        <span>
          <Button
            buttonStyle={ButtonStyle.TERTIARY_GRAY}
            className="u-mini-spacing-left"
            icon="arrows-rotate"
            onClick={this._handleRefreshCallback()}
            size={ButtonSize.MINI}
            disabled={this.props.disabled}
            dataTestAttrs={{component: 'RefreshStructuredTableButton', element: 'button'}}
          />
        </span>
      </Tooltip>
    );
  }
}
